import React from "react"

export default class FormHeaderLinks extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="FormHeaderLinks">
				{
					this.props.left
					?
					<div className="left">
						{this.props.left}
					</div>
					:
					null
				}
				{
					this.props.right
					?
					<div className="right">
						{this.props.right}
					</div>
					:
					null
				}
			</div>
		);	
	}

}